import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './SignUpWindow.css';
import downArrow from '../assets/images/down-arrow.svg';
import uploadImg from '../assets/images/upload.png';
import infoLogo from "../assets/images/q-mark.png";
import { NETWORK } from '../Constants';
import { Lucid, Blockfrost } from 'lucid-cardano';


const SignUpWindow = ({ walletAPI,walletName,walletIcon,lucid,openWalletMenu,onClose,setLoggedIn,setAccountInfo,selectedIPID,selectedSPOID,setMessageWindowContent,setMessageWindowButtonText,setShowMessageWindow}) => {

  const navigate = useNavigate();

  const [userType,setUserType] = useState("SPO");
  const [userPFP,setUserPFP] = useState();
  const [userPFPsrc,setUserPFPsrc] = useState(uploadImg);

  let reader = new FileReader();
  reader.onload = (e) => {
    setUserPFPsrc(e.target.result);
  };

  const closeWindow = (event) => {
      if(event.target.className.toString()==="backdrop"){ 
        onClose();
    }

  }

  async function handleRegistration() {
    let registrationSuccess = false;

    try {
      let selectedUserType = document.getElementById('userType').value;
      let displayName = document.getElementById('dispalyNameInput').value;
      let poolID = document.getElementById('poolIDInput')?.value;
      let website = document.getElementById('websiteInput').value;
      let socialLink = document.getElementById('socialLinkInput').value;
      let selectedUserPFP = document.getElementById('userPFPInput').files[0];

      setMessageWindowContent("Checking user input...");
      setMessageWindowButtonText('');
      setShowMessageWindow(true);

      if (displayName.replace(/\s/g, "").length < 5) {
        throw new Error("Display name has to be longer than 4 charecters.");
      }

      if (selectedUserPFP === undefined) {
        throw new Error("It is always better to upload a profile picture.");
      }

      const walletKeyByName = {
        Nami: 'nami',
        Eternl: 'eternl',
        Flint: 'flint',
        Typhon: 'typhon',
      };

      const selectedWalletKey = walletKeyByName[walletName] || 'eternl';
      if (!window.cardano || !window.cardano[selectedWalletKey]) {
        throw new Error(`${walletName || 'Selected wallet'} not detected. Please unlock/install the extension and try again.`);
      }

      const connectedWalletAPI = walletAPI || await window.cardano[selectedWalletKey].enable();
      if (!connectedWalletAPI) {
        throw new Error('Wallet connection was not established.');
      }

      let lucidInstance = lucid;
      if (!lucidInstance) {
        lucidInstance = await Lucid.new(
          new Blockfrost(
            NETWORK === 0
              ? 'https://cardano-preview.blockfrost.io/api/v0'
              : 'https://cardano-mainnet.blockfrost.io/api/v0',
            NETWORK === 0
              ? 'preview7iVl38anG9Np8lT4JzXCKB16mxPC8Kyg'
              : 'mainnetedOr1A0jt3OG6NJ4dI0U59cFb42hgD3t',
          ),
          NETWORK === 0 ? 'Preview' : 'Mainnet',
        );
      }

      if (!lucidInstance) {
        throw new Error('Wallet service is not ready yet. Please try again.');
      }

      lucidInstance.selectWallet(connectedWalletAPI);
      let paymentAddress = await lucidInstance.wallet.address();
      let stakeAddress = await lucidInstance.wallet.rewardAddress();
      let walletNetwork = await connectedWalletAPI.getNetworkId();

      //exit if wallet network does not match dapp network
      if (walletNetwork !== NETWORK) {
        throw new Error("Please select correct wallet's network.");
      }

      if (selectedUserType == "SPO") {
        if (await isAccountRegistered(selectedUserType, "poolID", poolID)) {
          throw new Error("Can not create account. This pool ID is already associated with an account.");
        }
        if (poolID.substring(0, 4) != "pool") {
          throw new Error('Pool ID must start with "pool1...".');
        }
      }

      if (await isAccountRegistered(selectedUserType, "stakeAddress", stakeAddress)) {
        throw new Error("Can not create account. This wallet is already associated with an account.");
      }

      //create formData object and populate the account data
      let newAccountData = new FormData();
      newAccountData.append('network', NETWORK);
      newAccountData.append('userType', selectedUserType);
      newAccountData.append('displayName', displayName);
      newAccountData.append('poolID', poolID);
      newAccountData.append('website', website);
      newAccountData.append('socialLink', socialLink);
      newAccountData.append('userPFP', selectedUserPFP, selectedUserPFP.name);
      newAccountData.append('walletType', walletName || selectedWalletKey);

      newAccountData.append('paymentAddress', paymentAddress);
      newAccountData.append('stakeAddress', stakeAddress);

      let url = "/api/create-new-account.php";
      let queryResponse = await fetch(url, {
        method: 'POST',
        mode: 'cors',
        cache: 'no-cache',
        credentials: 'same-origin',

        redirect: 'follow',
        referrerPolicy: 'no-referrer',
        body: newAccountData,
      });

      let queryResult = await queryResponse.text();

      if (queryResult === "New record created successfully") {
        let response = await fetch('/api/get-account-info.php?stakeAddress=' + stakeAddress, { cache: 'reload' });
        let accountInfo = JSON.parse(await response.text());
        setAccountInfo(accountInfo);
        setLoggedIn(true);
        setMessageWindowContent("Your account has been created successfully!");
        setMessageWindowButtonText("Ok");
        setShowMessageWindow(true);
        onClose();
        navigate('/profile');
        selectedSPOID = "0";
        selectedIPID = "0";
        registrationSuccess = true;
      } else {
        throw new Error(queryResult || 'Unable to create new account.');
      }
    } catch (error) {
      localStorage.removeItem('lastConnectedWalletName');
      document.cookie = 'lastConnectedWalletName=; Max-Age=0; path=/';
      setMessageWindowContent(error?.message || 'Unexpected error while creating the account.');
      setMessageWindowButtonText('OK');
      setShowMessageWindow(true);
    } finally {
      if (!registrationSuccess) {
        setMessageWindowButtonText('OK');
      }
    }
  }


  async function isAccountRegistered(userType,checkWith,checkValue){
        
    let response, accountInfo;
    response = await fetch('/api/is-account-registered.php?userType='+userType+'&'+checkWith+'='+checkValue); 
    accountInfo = JSON.parse(await response.text());
    
    if(accountInfo=="-1"){
        return false;
    }
    else
        return true;
  }


  return (
    <div className="backdrop" onClick={closeWindow}>
      <div className='signup-menu'>
        <h3>Sign Up</h3>
        <br/>
        <div style={{display:"flex",gap:"30px"}}>
          <div className='sign-up-text-fields-area'>
            <div className='sign-up-text-field'>
              <div className='sign-up-text-field-title'>User Type
              <a className="qMark"><img src={infoLogo} width="15px" height={"15px"} /><p className="tooltiptext slide-in-fwd-center">{userType=="SPO"?"SPO stands for Stake Pool Operator.":"Affiliate is an influencer who works on bringing stake to SPOs. For more information read about \"Affiliate Marketing\" concept."}</p></a>
              :
              </div>
              <div className='sign-up-text-field-input' >
                <select id="userType" style={{height:"25px"}} onChange={() => setUserType(document.getElementById("userType").value)}>
                  <option value={"SPO"}>SPO</option>
                  <option value={"Affiliate"}>Affiliate</option>
                </select>
              </div>
            </div>
            <div className='sign-up-text-field'>
              <div className='sign-up-text-field-title'>Display Name:</div>
              <div className='sign-up-text-field-input' style={{flex:1}}>
                <input type='text' id='dispalyNameInput' style={{width:"100%",height:"20px"}}></input>
              </div>
            </div>
            {userType==="SPO"?
            <div className='sign-up-text-field'>
              <div className='sign-up-text-field-title'>Pool ID:</div>
              <div className='sign-up-text-field-input' style={{flex:1,marginLeft:"7px"}}>
                <input type='text' id='poolIDInput' style={{width:"100%",height:"20px"}}></input>
              </div>
            </div>
            :
            <></>}
            <div className='sign-up-text-field'>
              <div className='sign-up-text-field-title'>Website:</div>
              <div className='sign-up-text-field-input' style={{flex:1}}>
                <input type='text' id='websiteInput' style={{width:"100%",height:"20px"}}></input>
              </div>
            </div>
            <div className='sign-up-text-field'>
              <div className='sign-up-text-field-title'>Social Link:</div>
              <div className='sign-up-text-field-input' style={{flex:1}}>
                <input type='text' id='socialLinkInput' style={{width:"100%",height:"20px"}}></input>
              </div>
            </div>
            <div className='sign-up-text-field' >
              <div className='sign-up-text-field-title'>Wallet:</div>
              <div className='sign-up-text-field-input' >
                <div className='select-wallet-div' style={{height:"25px"}} onClick={() => openWalletMenu("signup")}>
                  {walletAPI !== undefined?
                  <>
                    <img src={walletIcon} alt="" width='16px' height={20}/>
                    <div style={{color:"black"}}>{walletName}</div>
                    <img src={downArrow} alt='' height={5} />
                  </>
                  :
                  <>
                    <div>Select</div>
                    <img src={downArrow} alt='' height={5}/>                  
                  </>
                  }
                </div>
              </div>
            </div>
          </div>
          <div className='sign-up-img-upload'>
            <label>
            <img className='sign-up-img-element' alt='' src={userPFPsrc} width={"100%"}/>
            <input type='file' name='userPFP' style={{display:"none"}} id='userPFPInput' placeholder='' accept='image/png,image/jpeg' 
                        onChange={() => {setUserPFP(document.getElementById('userPFPInput').files[0]);reader.readAsDataURL(document.getElementById('userPFPInput')?.files[0]);}} />
            </label>
          </div>
        </div>
        <div style={{textAlign:"right",marginTop:"2rem"}}>
          <button className='btnType1' style={{width:"120px"}} onClick={async () => await handleRegistration()}>Register</button>
        </div>
      </div>
    </div>
  );
};

export default SignUpWindow;
